export const compensationKeys = {
  all: ['compensation'] as const,
  rules: () => [...compensationKeys.all, 'rules'] as const,
  rule: (profileId: string, ruleType?: string) => [...compensationKeys.rules(), profileId, ruleType] as const,
  calculations: () => [...compensationKeys.all, 'calculations'] as const,
  calculation: (profileId: string, startDate: string, endDate: string) => 
    [...compensationKeys.calculations(), profileId, startDate, endDate] as const,
  previews: () => [...compensationKeys.all, 'previews'] as const,
  preview: (profileIds: string[], startDate: string, endDate: string) => 
    [...compensationKeys.previews(), profileIds, startDate, endDate] as const,
} as const;